<aw-wizard
  #wizard
  [navBarLayout]="'large-empty-symbols'"
  [class.no-step-header]="pageData.inputContentGroupLists.length === 1"
>
  <aw-wizard-step
    [canExit]="canExit.bind(this)"
    *ngFor="
      let inputContentGroupListItem of pageData.inputContentGroupLists;
      let i = index;
      let isFirst = first;
      let isLast = last
    "
  >
    <form [formGroup]="pageData.formGroupList[i]">
      <ng-template awWizardStepSymbol>{{ i + 1 }} </ng-template>
      <client-form-instruction *ngIf="i === 1 && licenseId === 3" />
      <client-form-page-step
        [formGroupInput]="pageData.formGroupList[i]"
        [inputContentGroupList]="inputContentGroupListItem"
      >
      </client-form-page-step>
      <!-- Adding Recaptcha on Last page-->
      <ng-container *ngIf="!preview && isLast">
        <div class="g-recaptcha">
          <ng-container *ngIf="captchaSiteKeyObs | async as captchaSiteKey">
            <re-captcha
              formControlName="recaptcha"
              required
              [siteKey]="captchaSiteKey"
            >
            </re-captcha>
          </ng-container>
        </div>
      </ng-container>
    </form>
    <div class="d-flex align-items-center mb-3">
      <button
        *ngIf="!preview && isLast"
        type="button"
        class="btn btn-success mx-1"
        [disabled]="disableSubmit || (processing$ | async)"
        (click)="submit()"
        [tooltip]="disableSubmitReason"
        [isDisabled]="!disableSubmit || !disableSubmitReason"
      >
        Submit
      </button>
      <button
        *ngIf="!isLast"
        type="button"
        class="btn btn-success mx-1"
        (click)="next()"
        awNextStep
      >
        Next
      </button>
      <button
        *ngIf="!isFirst"
        type="button"
        class="btn btn-outline-secondary mx-1"
        awPreviousStep
      >
        Back
      </button>
      <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="reset()"
        [disabled]="processing$ | async"
        awResetWizard
      >
        Reset
      </button>
    </div>
  </aw-wizard-step>
</aw-wizard>
